export default {
	namespaced: true,

	state: {
		loanDeductions: [],
		interestRates: [],
		loanableAmounts: [],
		loanApplications: [],
		terms: [],
		paymentModes: [],
		requirements: [],
		renewals: [],
	},

	mutations: {
		/**
		 * [setRenewals description]
		 * @param {[type]} state    [description]
		 * @param {[type]} renewals [description]
		 */
		setRenewals(state, renewals) {
			state.renewals= renewals
		},

		/**
		 * [removeLoanApplication description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} loan_id [description]
		 * @return {[type]}         [description]
		 */
		removeLoanApplication(state, loan_id) {
			for(var i=0; i<state.loanApplications.length; i++) {
				if(state.loanApplications[i].id==loan_id) {
					state.loanApplications.splice(i,1)
					break;
				}
			}
		},

		/**
		 * [setLoanApplications description]
		 * @param {[type]} state        [description]
		 * @param {[type]} applications [description]
		 */
		setLoanApplications(state, applications) {
			state.loanApplications=applications
		},

		/**
		 * [setRequirements description]
		 * @param {[type]} state        [description]
		 * @param {[type]} requirements [description]
		 */
		setRequirements(state, requirements) {
			state.requirements= requirements
		},

		/**
		 * [setPaymentModes description]
		 * @param {[type]} state        [description]
		 * @param {[type]} paymentModes [description]
		 */
		setPaymentModes(state, paymentModes) {
			state.paymentModes= paymentModes
		},

		/**
		 * [setTerms description]
		 * @param {[type]} state [description]
		 * @param {[type]} terms [description]
		 */
		setTerms(state, terms) {
			state.terms = terms
		},

		/**
		 * [setLoanableAmounts description]
		 * @param {[type]} state           [description]
		 * @param {[type]} loanableAmounts [description]
		 */
		setLoanableAmounts(state, loanableAmounts) {
			state.loanableAmounts = loanableAmounts
		},

		/**
		 * [setInterestRates description]
		 * @param {[type]} state         [description]
		 * @param {[type]} interestRates [description]
		 */
		setInterestRates(state, interestRates) {
			state.interestRates = interestRates
		},

		/**
		 * [setLoanDeductions description]
		 * @param {[type]} state          [description]
		 * @param {[type]} loanDeductions [description]
		 */
		setLoanDeductions(state, loanDeductions) {
			state.loanDeductions = loanDeductions
		}
	},

	getters: {
		/**
		 * [renewals description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		renewals(state) {
			return state.renewals
		},

		/**
		 * [loanApplications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loanApplications(state) {
			return state.loanApplications
		},

		/**
		 * [requirements description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		requirements(state) {
			return state.requirements
		},

		/**
		 * [notatialFee description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		notarialFee(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('NOTARIALFEE')
			})
		},

		/**
		 * [paymentModes description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		paymentModes(state) {
			return state.paymentModes
		},

		/**
		 * [terms description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		terms(state) {
			return state.terms
		},

		/**
		 * [loanableAmounts description]
		 * @param  {[type]} state           [description]
		 * @param  {[type]} loanableAmounts [description]
		 * @return {[type]}                 [description]
		 */
		loanableAmounts(state) {
			return state.loanableAmounts
		},

		/**
		 * [interestRates description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		interestRates(state) {
			return state.interestRates
		},

		/**
		 * [loanDeductions description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loanDeductions(state) {
			return state.loanDeductions
		},

		/**
		 * [service_charges description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		service_charges(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('SERVICECHARGE')
			})
		},

		/**
		 * [penalty description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		penalty(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('PENALTY')
			})
		},

		/**
		 * [capital_retention description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		capital_retention(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('CAPITALRETENTION')
			})
		},

		/**
		 * [advance_interest description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		advance_interest(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('ADVANCEINTEREST')
			})
		},

		/**
		 * [loan_insurance description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loan_insurance(state) {
			return state.loanDeductions.filter(item => {
				return item.code.startsWith('LOANINSURANCE')
			})
		}
	},

	actions: {
		/**
		 * [publishLoan description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} loan_id         [description]
		 * @return {[type]}                 [description]
		 */
		unpublishLoan({commit, getters}, loan_id) {
			return this._vm.$http.get('loan-applications/update/unpublish/'+loan_id)
				.then(response => {
					return response.data
				})
		},
		/**
		 * [publishLoan description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} loan_id         [description]
		 * @return {[type]}                 [description]
		 */
		publishLoan({commit, getters}, loan_id) {
			return this._vm.$http.get('loan-applications/update/publish/'+loan_id)
				.then(response => {
					return response.data
				})
		},

		/**
		 * [updateLoanInformation description]
		 * @return {[type]} [description]
		 */
		updateLoanInformation({commit, getters}, {loan_id, form}) {
			const formData = new FormData()
			formData.append('thumbnail', (form.thumbnail||{file: null}).file)
			formData.append('title', form.title)
			formData.append('shortCode', form.shortCode)
			formData.append('description', form.description)
			formData.append('appType', form.appType)
			formData.append('prType', form.prType)
			formData.append('glCode', form.glCode)
			formData.append('computation', form.computation)
			return this._vm.$http.post('loan-applications/update/information/'+loan_id, formData)
				.then(response => {
					return response.data
				})
		},

		/**
		 * [getUtilRenewals description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getUtilRenewals({commit, getters}, payload) {
			if(getters['renewals'].length) {
				return Promise.resolve(getters['renewals'])
			}
			return this._vm.$http.get('loan-applications/utility/renewals')
				.then(response => {
					commit('setRenewals', response.data)
					return response.data
				})
		},

		/**
		 * [removeLoanApplication description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} loan_id         [description]
		 * @return {[type]}                 [description]
		 */
		removeLoanApplication({commit, getters}, loan_id) {
			return this._vm.$http.delete('loan-applications/remove/'+loan_id)
				.then(response => {
					commit('removeLoanApplication', loan_id)
					return response.data
				})
		},

		/**
		 * [getLoanApplication description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		getLoanApplication({commit, getters}, application_id) {
			return this._vm.$http.get('loan-applications/detail/'+application_id)
		},

		/**
		 * [getLoans description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getLoanApplications({commit, getters}, payload) {
			return this._vm.$http.get('loan-applications')
				.then(response => {
					commit('setLoanApplications', response.data)
					return response.data
				})
		},

		/**
		 * [saveLoanApplication description]
		 * @param  {[type]} (commit, getters)      [description]
		 * @param  {[type]} form     [description]
		 * @return {[type]}          [description]
		 */
		saveLoanApplication({commit, getters}, form) {
			const formData= new FormData()

			Object.keys(form).forEach((key) => {
				const value=form[key]
				switch(key) {
					case 'thumbnail':
						formData.append(key, value.file)
						break
					case 'requirements':
						value.forEach((val, index) => {
							formData.append(key+'['+index+'][id]', val.id)
							formData.append(key+'['+index+'][is_new]', val.is_new)
							formData.append(key+'['+index+'][need_doc]', val.need_doc)
						})
						break
					case 'interestRate':
					// case 'loanableAmount':
					case 'modeOfPayments':
					case 'serviceCharge':
					case 'term':
						value.forEach(val => {
							formData.append(key+'[]', val)
						})
						break
					default:
						formData.append(key, value)
				}
			})
			return this._vm.$http.post('loan-applications', formData)
		},


		/**
		 * [getRequirements description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getRequirements({commit, getters}, payload) {
			if(getters['requirements'].length) {
				return Promise.resolve(getters['requirements'])
			}
			return this._vm.$http.get('loan-applications/utility/requirements')
				.then(response => {
					commit('setRequirements', response.data)
					return response.data
				})
		},

		/**
		 * [getPyamentMethods description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getPaymentModes({commit, getters}, payload) {
			if(getters['paymentModes'].length) {
				return Promise.resolve(getters['paymentModes'])
			}
			return this._vm.$http.get('loan-applications/utility/payment-modes')
				.then(response => {
					commit('setPaymentModes', response.data)
					return response.data
				})
		},

		/**
		 * [getTerms description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.getter [description]
		 * @param  {[type]} paypal         [description]
		 * @return {[type]}                [description]
		 */
		getTerms({commit, getters}, paypal) {
			if(getters['terms'].length) {
				return Promise.resolve(getters['terms'])
			}
			return this._vm.$http.get('loan-applications/utility/terms')
				.then(response => {
					commit('setTerms', response.data)
					return response.data
				})
		},

		/**
		 * [getLoanableAmounts description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getLoanableAmounts({commit, getters}, payload) {
			if(getters['loanableAmounts'].length){
				return Promise.resolve(getters['loanableAmounts'])
			}
			return this._vm.$http.get('loan-applications/utility/loanable-amounts')
				.then(response => {
					commit('setLoanableAmounts', response.data)
					return response.data
				})
		},

		/**
		 * [getInterestRates description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getInterestRates({commit, getters}, payload) {
			if(getters['interestRates'].length) {
				return Promise.resolve(getters['interestRates'])
			}
			return this._vm.$http.get('loan-applications/utility/interest-rates')
				.then(response => {
					commit('setInterestRates', response.data)
					return response.data
				})
		},

		/**
		 * [getDeductions description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getDeductions({commit, getters}, payload) {
			if(getters['loanDeductions'].length) {
				return Promise.resolve(getters['loanDeductions'])
			}
			return this._vm.$http.get('loan-applications/utility/deductions')
				.then(response => {
					commit('setLoanDeductions', response.data)
					return response.data
				})
		}
	}
}